import Swiper from 'swiper';
import {Autoplay, Pagination, Navigation, EffectFade, Scrollbar} from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';
import AOS from 'aos';
import 'aos/dist/aos.css';
const swiperVoice = () => {
    const swiper = new Swiper(".js-voice-swiper", {
        modules: [Navigation, Pagination],
        speed: 1000,
        slidesPerView: 2.8,
        spaceBetween: 20,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            addIcons: false
        },
        pagination: {
            el: '.swiper-pagination',
        },
    });
}

const swiperContact = () => {
    const swiper = new Swiper(".js-contact-swiper", {
        modules: [Pagination],
        speed: 1000,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
        },
    });
}

const banner = () => {
    const banner = document.querySelector('.pg-register-banner');
    const closeButton = banner.querySelector(".pg-register-banner__button")

    closeButton.addEventListener("click", () => {
        banner.style.display = "none";
    })
}

const main = () => {
    if (document.querySelector('#page-home') === null) return;
    swiperVoice();
    swiperContact();
    banner()

    AOS.init({
        offset: 0,
        duration: 700,
        easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        delay: 400,
        once: true
    })
}
export default main;
